<template>
  <div class="test">
    <Echart
        :options="options"
        id="bottomLeftChart"
        height="100%"
        width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        // 过滤barData低于30的数据
        const filterCategory = [];
        const filterBarData = [];
        if (newData.category && newData.barData) {
          newData.category.forEach((item, index) => {
            if (newData.barData[index] >= 50 && newData.barData[index] != null) {
              filterCategory.push(item);
              filterBarData.push(newData.barData[index]);
            }
          });
        }

        this.options = {
          title: { text: "" },
          tooltip: {
            trigger: "axis",
            formatter: (data) => `已使用：${data[0].value}%`,
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: { show: true, backgroundColor: "#7B7DDC" },
            },
          },
          legend: {
            data: newData.legendData,
            textStyle: { color: "#B4B4B4" },
            top: "0%",
          },
          // 保留原始图表宽度，不缩小！
          grid: { x: "8%", width: "88%", y: "6%", y2: "80" },
          xAxis: {
            data: filterCategory,
            axisLine: { lineStyle: { color: "#0D1223" } },
            boundaryGap: true, // 保留两端留白，不贴边
            // 关键1：极致拉大类目间间距（核心！）
            categoryGap: "200%",
            axisTick: { show: false },
            axisLabel: { interval: 0, rotate: 20, fontSize: 12, color: "black" },
          },
          yAxis: [
            { splitLine: { show: false }, axisLine: { lineStyle: { color: "#11152B" } }, axisLabel: { formatter: "{value}%" } },
            { splitLine: { show: false }, axisLine: { lineStyle: { color: "#B4B4B4" } }, axisLabel: { formatter: "{value}" } },
          ],
          series: [
            {
              name: newData.legendData[0],
              type: "bar",
              barWidth: 13, // 柱子宽度不变，避免粗导致挤
              // 关键2：极致拉开柱子专属间距（最高优先级！）
              barCategoryGap: "150%",
              itemStyle: {
                normal: {
                  barBorderRadius: 5,
                  // 保留原始渐变颜色
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#956FD4" },
                    { offset: 1, color: "#3EACE5" },
                  ]),
                },
              },
              data: filterBarData,
            },
          ],
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.test {
  width: 100%;
  height: 100%;
  margin-top: 2.5%;
  display: flex;
  align-items: center;
}
</style>